<template>
  <div>
    <div style="margin: 5px 0; line-height: 24px">用户: {{info.user.name}}</div>
    <div style="margin: 5px 0; line-height: 24px">关注项: {{info.enabledConcernedCount}} / {{info.concernedCount}}</div>
    <div style="margin: 5px 0; line-height: 24px">关键词: <el-tag v-for="kw in info.keyWords" size="mini" :key="kw" style="margin: 0 5px">{{kw}}</el-tag></div>
  </div>
</template>

<script>
import UserInfo from "@/models/UserInfo";

export default {
  name: "UserInfoView",
  props: {
    info: UserInfo
  }
}
</script>

<style scoped>

</style>
